import React from "react";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

export default function SingleAutocomplete({
  DataList,
  SelectedValue,
  Label,
  SetValue,
  HasValue,
  Required,
  Disabled
}) {
  if (HasValue) {
    return (
      <Autocomplete
        options={DataList}
        disabled={Disabled}
        getOptionLabel={(option) => option.text}
        value={SelectedValue ?? null}
        inputValue={SelectedValue ? SelectedValue.text : ""}
        onChange={(e, c) => SetValue(c)}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={Label}
            variant="outlined"
            required
            disabled={Disabled}
          />
        )}
      />
    );
  } else {
    return (
      <Autocomplete
        options={DataList}
        getOptionLabel={(option) => option.text}
        onChange={(e, c) => SetValue(c)}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={Label}
            variant="outlined"
            required={Required ?? false}
            name="test"
          />
        )}
      />
    );
  }
}
